import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Divider,
  Box
} from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CloseIcon from '@mui/icons-material/Close';

const ErrorDialog = ({ open, handleClose, message, errors }) => {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <Box sx={{ mt: 4, mb: 1, ml: 5, mr: 5 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 30,
            right: 30,
            backgroundColor: '#333333',
            padding: '4px',
            zIndex: 1,
            '&:hover': {
              backgroundColor: '#444444',
            },
          }}
        >
          <CloseIcon sx={{ color: '#ffffff', fontSize: '1.2rem' }} />
        </IconButton>

        <DialogContent sx={{ padding: '2rem 2rem 1.5rem 1rem' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>
                Please review the following issues
              </Typography>
            </Grid>

            <Grid item xs={12} sx={{ paddingTop: '5px !important', paddingBottom: '4px !important' }}>
              <Divider sx={{ borderBottom: '2px solid black' }} />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" sx={{ mb: 2 , fontSize: '1rem'}}>
                We found some configuration issues. Please correct them before saving.
              </Typography>

              {Array.isArray(errors) && errors.length > 0 && (
                <List dense>
                  {errors.map((err, idx) => (
                    <ListItem
                      key={idx}
                      sx={{
                        borderRadius: 1,
                        mb: 0.5,
                        '&:hover': {
                          backgroundColor: '#fff3e0',
                        },
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: '36px', color: '#ed6c02' }}>
                        <ReportProblemIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography variant="body2" sx={{ color: '#ed6c02' }}>
                            {err}
                          </Typography>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              )}
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ pr: 3, pb: 2 }}>
          <Button onClick={handleClose} variant="outlined">
            Review
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ErrorDialog;
